webpackJsonp([129236653009385],{

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(259);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(257),
	    baseFilter = __webpack_require__(260),
	    baseIteratee = __webpack_require__(108),
	    isArray = __webpack_require__(23);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyPluginPageTransitions = __webpack_require__(28);
	
	var _gatsbyPluginPageTransitions2 = _interopRequireDefault(_gatsbyPluginPageTransitions);
	
	var _get = __webpack_require__(41);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _startCase = __webpack_require__(195);
	
	var _startCase2 = _interopRequireDefault(_startCase);
	
	var _map = __webpack_require__(73);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _filter = __webpack_require__(263);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _find = __webpack_require__(352);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _index = __webpack_require__(35);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _reactHelmet = __webpack_require__(30);
	
	var _BlogMenu = __webpack_require__(83);
	
	var _BlogMenu2 = _interopRequireDefault(_BlogMenu);
	
	var _BlogPostExcerpt = __webpack_require__(59);
	
	var _BlogPostExcerpt2 = _interopRequireDefault(_BlogPostExcerpt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    _gatsbyPluginPageTransitions2.default,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'Atrakeur-Page' },
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement('meta', { charSet: 'utf-8' }),
	        _react2.default.createElement(
	          'title',
	          null,
	          'Atrakeur Blog | ',
	          (0, _startCase2.default)((0, _get2.default)(data, 'contentfulTag.name'))
	        )
	      ),
	      _react2.default.createElement(_index2.default, {
	        contentText: '<h1>' + (0, _startCase2.default)((0, _get2.default)(data, 'contentfulTag.name')) + '</h1>',
	        contentImage: (0, _get2.default)(data, 'contentfulTag.featuredImage.resolutions'),
	        size: 'medium' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'Atrakeur-Content' },
	        (0, _map2.default)((0, _filter2.default)(data.allContentfulBlogPost.edges, function (node) {
	          return (0, _find2.default)(node.node.tags, { id: data.contentfulTag.id });
	        }), function (_ref2, index) {
	          var post = _ref2.node;
	          return _react2.default.createElement(_BlogPostExcerpt2.default, { post: post, inverted: index % 2 == 1, key: post.id });
	        })
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tag-js-ab88a4e5da7346eb26ef.js